import { SuiteId } from '@libs/shared';

/**
 * 消息中心左侧导航栏的消息一级类型
 * 值和后端保持一致
 */
export enum MessageNavType {
    /**
     * 简道云导航栏icon
     */
    // 数据提醒.
    DataNotify = 'data_notify',
    // 应用日志.
    AppLog = 'app_log',
    // 文档动态.
    KmsDoc = 'kms_doc',
    /**
     * 九数云导航栏icon
     */
    // 项目提醒
    AnalyticsProjectNotify = 'analytics_project_notify',
    // 空间提醒
    AnalyticsSpaceNotify = 'analytics_space_notify',
    // 其他提醒
    AnalyticsOtherNotify = 'analytics_other_notify',
    /**
     * 集成治理导航栏icon
     */
    // 结果通知
    GovernanceResultNotification = 'governance_result_notification',
    /**
     * 企业消息导航栏icon
     */
    // 用量提醒.
    UsageNotify = 'usage_notify',
    // 运营通知.
    OperationNotify = 'operation_notify',
    // 通讯录管理.
    TenantCoop = 'tenant_coop',
    // 开放平台.
    OpenPlatform = 'open_platform',
    // 系统管理.
    SystemManagement = 'system_management',
    /**
     * 下面两个导航项较特殊，是维护在前端的，后端的相关接口中并不返回相应参数
     */
    // 消息设置.
    MessageSetting = 'message_setting',
    // 外部消息.
    External = 'external'
}

/**
 * 消息中心消息列表筛选项中的消息二级分类
 * 值和后端保持一致
 * 前端暂时不需要其具体的值，所以先不维护，后续要用的话可以通过git记录恢复
 */
export type MessageFilterType = string;

/**
 * 消息列表筛选项
 * @see https://fanruan-x.feishu.cn/wiki/TShjwURysim3kgkcXkzcRf2anLd 第2条
 */
export interface MessageFilterItem {
    key: MessageFilterType;
    label: string;
}

/**
 * 消息中心侧边导航栏项
 */
export interface MessageNavOption {
    /** 消息类型 */
    key: MessageNavType;
    /**
     * 消息文案（由后端提供）
     * @see https://fanruan-x.feishu.cn/wiki/EPwOw3R4CiuxGAkE1GbcrdTqnUh#share-TCcjdg57Lo6qhwxpO81cxkCenfg 4.1.4
     */
    label: string;
    children?: MessageFilterItem[];
}

/**
 * 消息中心侧边导航栏组
 */
export interface MessageNavGroup {
    /** 子产品消息导航项 */
    suite: MessageNavOption[];
    /** 平台（企业）消息导航项 */
    platform: MessageNavOption[];
}

/**
 * 子产品未读状态
 */
export interface SuiteUnreadStatus {
    suite_id: SuiteId;
    suite_name: string;
    has_unread: boolean;
}
